export const apiPath = '/v2/contracts';
const actionType = 'CONTRACTS_V2';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
